import { keepPreviousData, QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/services/api.service';

const MAX_QUERY_RETRIES = 2;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      // Only retry failures that look transient -- a genuine connectivity
      // blip (isNetworkError) or a real server error (5xx). A 4xx (403,
      // 404, 422, etc.) is deterministic: retrying repeats the exact same
      // failure, so those still fail immediately, same as before. Mutations
      // are untouched (no mutations.retry set) -- a write isn't safe to
      // retry blindly without knowing it's idempotent.
      retry: (failureCount, error) => {
        if (failureCount >= MAX_QUERY_RETRIES) return false;
        if (error instanceof ApiError) {
          return error.isNetworkError || error.status >= 500;
        }
        return false;
      },
      retryDelay: (attemptIndex) => Math.min(1000 * 2 ** attemptIndex, 4000),
      placeholderData: keepPreviousData,
    },
  },
});

export default queryClient;
